import mutations from './mutations';

const state = {
  navigation: {},
  pageNameMap: {},
  pageOriginalNameMap: {},
  fileNameMap: {},
  currentPage: {},
  navigationSet: false
};

const getters = {
  getPublicPages: (stateData) => {
    const publicPages = [];
    Object.entries(stateData.navigation).forEach(([key, page]) => {
      const filtered = Object.values(page).filter((item) => item.public);
      filtered.forEach((item) =>
        publicPages.push({
          moduleId: key,
          pageName: item.path
        })
      );
    });

    return publicPages;
  },

  getValidPageFromNav: (stateData) => (moduleId, pagePath) => {
    let resPath = '';

    if (moduleId !== undefined && pagePath !== undefined) {
      if (
        !Object.prototype.hasOwnProperty.call(stateData.navigation, moduleId) ||
        !stateData.navigation[moduleId]
      ) {
        resPath = '/';
      } else if (
        !Object.prototype.hasOwnProperty.call(stateData.navigation[moduleId], pagePath) ||
        !stateData.navigation[moduleId][pagePath]
      ) {
        const firstPath = 'README.md';
        resPath = firstPath;
      } else {
        resPath = pagePath;
      }
    } else {
      resPath = '/';
    }

    return resPath;
  },

  // TODO: checkInNav is used multiple components and every component duplicate this method.
  // When we are going to refactor the navigation, we can replace them with this getter.
  isPageInNav: (stateData) => (moduleId, pagePath) => {
    let res = false;
    if (
      !Object.prototype.hasOwnProperty.call(stateData.navigation, moduleId) ||
      !stateData.navigation[moduleId]
    ) {
      res = false;
    } else if (
      !Object.prototype.hasOwnProperty.call(stateData.navigation[moduleId], pagePath) ||
      !stateData.navigation[moduleId][pagePath]
    ) {
      res = false;
    } else {
      res = true;
    }
    return res;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
